import { FILTERS_ACTIONS, STATUS } from "../constant";

const initialState = {
  isLoading: STATUS.SUCCESS,
  selectedFilters: {},
  bubbleFilters: [],
  data: {}
};

const excludeFilters = selectedFilters => {
  const filters = [];
  Object.keys(selectedFilters).forEach(key => {
    if (
      ![
        "limit",
        "offset",
        "sortBy",
        "sortOrder",
        "search",
        "createdDate",
        "projectIdFilter",
        "groupCategory",
        "projectFilterType"
      ].includes(key)
    ) {
      filters.push({ [key]: selectedFilters[key] });
    }
  });

  return filters;
};

const excludeBasedOnFilteredData = (bubbleFilters, currentFiltersList) => {
  if (
    !currentFiltersList ||
    currentFiltersList.length === 0 ||
    !bubbleFilters
  ) {
    return bubbleFilters;
  }

  for (let i in bubbleFilters) {
    let bubbleFilter = bubbleFilters[i];
    let bubbleKey = Object.keys(bubbleFilter)[0];
    let currentFilter = currentFiltersList[bubbleKey];

    if (!currentFilter) {
      continue;
    }

    let keys = [];
    keys = currentFilter.values.map(filter => filter.key);
    bubbleFilter[bubbleKey] = bubbleFilter[bubbleKey].filter(filter => {
      return keys.includes(filter.key);
    });
  }
  return bubbleFilters;
};

export function projectListReducer(state = initialState, action) {
  try {
    let filter;
    switch (action.type) {
      case FILTERS_ACTIONS._PROJECT_LIST_._START:
        filter = { ...action.payload };
        return {
          ...state,
          isLoading: STATUS.LOADING,
          selectedFilters: filter,
          bubbleFilters: excludeFilters(filter),
          data: {}
        };

      case FILTERS_ACTIONS._PROJECT_LIST_._SUCCESS:
        return {
          ...state,
          isLoading: STATUS.SUCCESS,
          bubbleFilters: excludeBasedOnFilteredData(
            state.bubbleFilters,
            action.payload.filters
          ),
          data: action.payload
        };

      case FILTERS_ACTIONS._PROJECT_LIST_._FAILURE:
        return {
          ...state,
          isLoading: STATUS._FAILURE,
          data: {}
        };

      case FILTERS_ACTIONS._PROJECT_LIST_._CLEAR:
        filter = { ...action.payload };
        return {
          ...state,
          selectedFilters: filter,
          isLoading: STATUS._FAILURE,
          bubbleFilters: excludeFilters(filter),
          data: {}
        };

      default:
        return state;
    }
  } catch (error) {
    console.error(error);
  }
}
